import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {PricePlanDialogService} from "../../services/price-plan-dialog-service.service";

export class ProgramServiceAreasByDistanceTableRowCtrl implements IController {

  area: any;
  zone: any;
  serviceAreasOptionIds: string[];
  excludeServiceAreasIds: string[];
  onUpdateZone: Function;
  onDelete: Function;

  public isDesktop: boolean;

  /* @ngInject */
  constructor(private pricePlanDialogService: PricePlanDialogService, private $mdMedia) {
    this.isDesktop = $mdMedia('gt-md');
  }

  $onInit() {

  }

  $onChanges(changes) {

  }

  onServiceAreaSelect(serviceArea) {

    if (!serviceArea) {
      return;
    }

    this.zone.toId = _.get(serviceArea, 'id');
    this.zone.name = _.get(serviceArea, 'areaName');
    this.updateRequired();
  }

  onZoneChange(zone) {
    this.zone = zone;
    this.updateRequired();
  }

  onEditZone($event, zone, area) {
    this.pricePlanDialogService.editPricePlanAreaByDistanceConfiguration($event, this.zone)
      .then((updatedZone) => {
        this.zone = updatedZone;
        this.updateRequired();
      })
  }

  updateRequired() {
    this.onUpdateZone({zone: this.zone, areaId: this.area.id});
  }

}

angular
  .module('bringoz.admin.pricePlan')
  .component('programServiceAreasByDistanceTableRow', {
    bindings: {
      zone: '<',
      area: '<',
      serviceAreasOptionIds: '<?',
      excludeServiceAreasIds: '<?',
      onUpdateZone: '&',
      onDelete: '&'
    },
    template: require('./program-service-areas-by-distance-table-row.html').default,
    controller: ProgramServiceAreasByDistanceTableRowCtrl
  });
